import { useEffect, useState } from "react";
import ServicioComun from "../../../../servicios/Comun";

function PaisesDropdown({
  id,
  name,
  value,
  onChange,
  permiteSeleccionar = "true",
  className = "",
  ...props
}) {
  const [paises, setPaises] = useState([]);

  const claseFinal = `form-control ${className}`.trim();

  useEffect(() => {
    async function obtenerPaises() {
      const paises = await ServicioComun.ObtengaListaPaises();
      setPaises(paises);
    }

    obtenerPaises();
  }, []);

  return (
    <select
      id={id}
      className={claseFinal}
      disabled={!permiteSeleccionar}
      name={name}
      value={value}
      onChange={onChange}
    >
      <option key="" value="">
        -
      </option>
      {paises.map((item) => (
        <option key={item.codigoPais} value={item.codigoPais}>
          {item.nombrePais}
        </option>
      ))}
    </select>
  );
}

export default PaisesDropdown;
